import { IeLynxObject } from "../../common/models/eLynxObject";
import { ITagAndTatID } from "../../services/tag-value-data-service/Models";

export const keys = {
    all: ["object"],
    data: (customerID: number, groupID: number, eLynxObject: IeLynxObject, tagAndTatIDs: Array<ITagAndTatID>, startDate: Date | undefined, endDate: Date | undefined, offline: boolean) => [
        ...keys.all,
        "values", {
            customerID,
            groupID,
            eLynxObject,
            tagAndTatIDs,
            startDate,
            endDate,
            offline
        }
    ]
};